import React from "react";
import { GContributionLimitsContainer } from "../../../containers";

const GContributionLimit = (props) => {
  return <GContributionLimitsContainer {...props} />;
};

export default GContributionLimit;
